// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messaging-section {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  min-height: 100vh;
  padding: 40px 0;
}

.messaging-card {
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  border: 1px solid rgba(212,175,55,0.2);
  overflow: hidden;
}

.messaging-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid rgba(212,175,55,0.2);
  background: linear-gradient(45deg, rgba(212,175,55,0.05) 0%, transparent 100%);
}

.messaging-title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #2d2d2d;
  font-size: 24px;
  font-weight: 300;
  margin: 0;
}

.messaging-title i {
  color: #d4af37;
  font-size: 28px;
}

.messaging-error {
  margin: 16px 32px 0;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(231, 76, 60, 0.12);
  border: 1px solid rgba(231, 76, 60, 0.35);
  color: #c0392b;
  font-size: 14px;
}

.unread-count {
  background: #d4af37;
  color: #1a1a1a;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.messages-inbox {
  max-height: 600px;
  overflow-y: auto;
}

.inbox-item {
  display: flex;
  align-items: center;
  padding: 16px 32px;
  border-bottom: 1px solid rgba(212,175,55,0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.inbox-item:hover {
  background: rgba(212,175,55,0.05);
}

.inbox-item.unread {
  background: rgba(212,175,55,0.08);
  border-left: 4px solid #d4af37;
}

.message-avatar {
  margin-right: 16px;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-avatar i {
  font-size: 40px;
  color: #d4af37;
}

.message-avatar .avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #f1f5f9;
}

.message-thread {
  padding: 24px 32px 32px;
}

.thread-back {
  border: none;
  background: transparent;
  color: #666;
  font-size: 14px;
  padding: 0 0 16px;
  cursor: pointer;
}

.thread-back:hover {
  color: #d4af37;
}

.thread-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.thread-body {
  white-space: pre-wrap;
  color: #2d2d2d;
  font-size: 15px;
  line-height: 1.55;
  padding: 16px 20px;
  background: rgba(212, 175, 55, 0.06);
  border-radius: 12px;
}

.message-info {
  flex: 1;
}

.message-sender {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.message-sender strong {
  color: #2d2d2d;
  font-size: 16px;
}

.message-time {
  color: #666;
  font-size: 12px;
}

.message-subject {
  color: #2d2d2d;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.message-preview {
  color: #666;
  font-size: 13px;
  line-height: 1.4;
}

.message-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.message-actions i {
  color: #ccc;
  cursor: pointer;
  transition: color 0.3s ease;
}

.message-actions i:hover {
  color: #d4af37;
}

.message-actions .starred {
  color: #d4af37;
}

.unread-indicator {
  color: #d4af37 !important;
  font-size: 8px;
}

.no-messages {
  text-align: center;
  padding: 60px 32px;
  color: #666;
}

.no-messages i {
  font-size: 48px;
  color: #d4af37;
  margin-bottom: 16px;
}

.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  border-top: 1px solid rgba(212,175,55,0.2);
  background: rgba(212,175,55,0.02);
}

.page-info {
  color: #666;
  font-size: 14px;
}

@media (max-width: 768px) {
  .messaging-header {
    padding: 16px 20px;
  }

  .inbox-item {
    padding: 12px 20px;
  }

  .message-sender {
    flex-direction: column;
    align-items: flex-start;
  }

  .pagination-controls {
    padding: 16px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/messaging/messaging.component.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;EACnB,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".messaging-section {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  min-height: 100vh;\n  padding: 40px 0;\n}\n\n.messaging-card {\n  background: rgba(255,255,255,0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3);\n  border: 1px solid rgba(212,175,55,0.2);\n  overflow: hidden;\n}\n\n.messaging-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  border-bottom: 1px solid rgba(212,175,55,0.2);\n  background: linear-gradient(45deg, rgba(212,175,55,0.05) 0%, transparent 100%);\n}\n\n.messaging-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #2d2d2d;\n  font-size: 24px;\n  font-weight: 300;\n  margin: 0;\n}\n\n.messaging-title i {\n  color: #d4af37;\n  font-size: 28px;\n}\n\n.messaging-error {\n  margin: 16px 32px 0;\n  padding: 12px 16px;\n  border-radius: 8px;\n  background: rgba(231, 76, 60, 0.12);\n  border: 1px solid rgba(231, 76, 60, 0.35);\n  color: #c0392b;\n  font-size: 14px;\n}\n\n.unread-count {\n  background: #d4af37;\n  color: #1a1a1a;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.messages-inbox {\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.inbox-item {\n  display: flex;\n  align-items: center;\n  padding: 16px 32px;\n  border-bottom: 1px solid rgba(212,175,55,0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.inbox-item:hover {\n  background: rgba(212,175,55,0.05);\n}\n\n.inbox-item.unread {\n  background: rgba(212,175,55,0.08);\n  border-left: 4px solid #d4af37;\n}\n\n.message-avatar {\n  margin-right: 16px;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.message-avatar i {\n  font-size: 40px;\n  color: #d4af37;\n}\n\n.message-avatar .avatar-img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #f1f5f9;\n}\n\n.message-thread {\n  padding: 24px 32px 32px;\n}\n\n.thread-back {\n  border: none;\n  background: transparent;\n  color: #666;\n  font-size: 14px;\n  padding: 0 0 16px;\n  cursor: pointer;\n}\n\n.thread-back:hover {\n  color: #d4af37;\n}\n\n.thread-header {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.thread-body {\n  white-space: pre-wrap;\n  color: #2d2d2d;\n  font-size: 15px;\n  line-height: 1.55;\n  padding: 16px 20px;\n  background: rgba(212, 175, 55, 0.06);\n  border-radius: 12px;\n}\n\n.message-info {\n  flex: 1;\n}\n\n.message-sender {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.message-sender strong {\n  color: #2d2d2d;\n  font-size: 16px;\n}\n\n.message-time {\n  color: #666;\n  font-size: 12px;\n}\n\n.message-subject {\n  color: #2d2d2d;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.message-preview {\n  color: #666;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.message-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.message-actions i {\n  color: #ccc;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.message-actions i:hover {\n  color: #d4af37;\n}\n\n.message-actions .starred {\n  color: #d4af37;\n}\n\n.unread-indicator {\n  color: #d4af37 !important;\n  font-size: 8px;\n}\n\n.no-messages {\n  text-align: center;\n  padding: 60px 32px;\n  color: #666;\n}\n\n.no-messages i {\n  font-size: 48px;\n  color: #d4af37;\n  margin-bottom: 16px;\n}\n\n.pagination-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 32px;\n  border-top: 1px solid rgba(212,175,55,0.2);\n  background: rgba(212,175,55,0.02);\n}\n\n.page-info {\n  color: #666;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .messaging-header {\n    padding: 16px 20px;\n  }\n\n  .inbox-item {\n    padding: 12px 20px;\n  }\n\n  .message-sender {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .pagination-controls {\n    padding: 16px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
